import './index.scss';

import React from 'react';

const DealsOfTheDay = props => {
  const { item, ImgOnclick } = props;
  const { image_url } = item;
  return (
    <div
      className="deals-day u_cursor_pointer"
      onClick={() => ImgOnclick(item)}
      role="presentation"
    >
      <img
        src={image_url}
        alt={item}
        className="deals-day__image u_width_height"
      />
      {/* <div className="deals-day__circle" asdf/>
      <div className="deals-day__circle deals-day__circle-right" /> */}{' '}
      {/* <div className="deals-day__circle" asdf/>
      <div className="deals-day__circle deals-day__circle-right" /> */}
    </div>
  );
};

export default DealsOfTheDay;
